// Employee preferences — HR/Manager case view (Employee Portal & App §9.4.1 /
// §14). Renders the matrix-filtered `RoleVisiblePreferences` the API returns
// for the requesting role: HR sees every "full" field; a Manager sees fewer,
// with "limited if relevant" fields named but not valued. The gate is
// server-side — this component only ever receives what the role may see.

import {
  describeSpecPreferences,
  describeLimitedPreferenceKeys,
} from '@besideu/shared/preference-display';
import type { RoleVisiblePreferences } from '@besideu/shared/preference-visibility';

export function EmployeePreferencesPanel({ preferences }: { preferences: RoleVisiblePreferences }) {
  const rows = describeSpecPreferences(preferences.visible);
  const limited = describeLimitedPreferenceKeys(preferences.limited);

  return (
    <section className="rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold">Their preferences</h2>
      {rows.length === 0 && limited.length === 0 ? (
        <p className="mt-1 text-sm text-muted-foreground">No preferences recorded yet.</p>
      ) : (
        <>
          <p className="mt-1 text-sm text-muted-foreground">
            How this employee has asked to be supported. Please respect these.
          </p>
          {rows.length > 0 && (
            <dl className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {rows.map((r) => (
                <div key={r.key}>
                  <dt className="text-xs tracking-wide text-muted-foreground uppercase">
                    {r.label}
                  </dt>
                  <dd className="mt-1 text-sm">{r.value}</dd>
                </div>
              ))}
            </dl>
          )}
          {limited.length > 0 && (
            <p className="mt-4 text-sm text-muted-foreground">
              Other relevant preferences ({limited.join(', ')}) are held by HR — ask HR if you need
              the detail.
            </p>
          )}
        </>
      )}
    </section>
  );
}
